import React from 'react'
import { Pie } from 'react-chartjs-2'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'

ChartJS.register(ArcElement, Tooltip, Legend)

const PieChartAsDonut = ({ percentage }) => {
  const data = {
    labels: ['Vinculados', 'No vinculados'],
    datasets: [
      {
        data: [percentage * 100, 100 - percentage * 100],
        backgroundColor: ['#ade757', '#E0E0E0'],
        borderWidth: 1,
      },
    ],
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '50%',  // Esto convierte el Pie en Donut
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
      },
    },
  }

  return <Pie data={data} options={options} />
}

export default PieChartAsDonut
